import Pickr from "@simonwep/pickr";
import $ from "jquery";
import {
  changeSceneTime,
  currentOS,
  GetGroup,
  hideIcon,
  pergola,
  pergolaConst,
  showIcon,
} from "../../core/3d-configurator";
import { removeFromUrlSystemBySideAndtype } from "../../core/customFunctions/initiSubSystem";
import { state } from "../../core/settings";
import { deleteActiveClassFromContainerRadioType } from "../Interface/interface";
import { updateTextParam } from "../Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import {
  addInfoLabel,
  generateRangeHTML,
} from "../Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange";
import "./portals.scss";
import { removeFromUrlHeater } from "../../core/customFunctions/initHeaters";

export const lightRange = [
  {
    title: "Spacing",
    min: 2,
    max: 8,
    step: 1,
    thumb: true,
    initialValue: state.recessedLighting,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shadesRange = [
  {
    title: "Shades",
    min: 1,
    labelMin: "0",
    max: 90,
    step: 1,
    thumb: false,
    initialValue: state.zipInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const bladeRotation = [
  {
    title: "Blade Rotation",
    min: 1,
    labelMin: "0",
    max: 120,
    step: 1,
    thumb: false,
    initialValue: state.currentRotationZ,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const slidingDoorRotation = [
  {
    title: "Sliding Door",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.slidingDoorInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const zipShadeRange = [
  {
    title: "",
    min: 1,
    labelMin: "Open",
    max: 100,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.zipInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldDoorRange = [
  {
    title: "bi-fold",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const slidingShutters = [
  {
    title: "Open",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.slidingShuttersInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shuttersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 180,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.slidingShuttersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const fixShuttersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 180,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.slidingFixShuttersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldShatters = [
  {
    title: "Open",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorShattersInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldShattersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 100,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorShattersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

function createHandleRange(
  compare,
  portalContainer,
  stateKey,
  inputSelector = ".range__input"
) {
  if (compare) {
    const $rangeInput = portalContainer.find(inputSelector);

    // ✅ INIT
    $rangeInput.val(state[stateKey]);

    const min = parseInt($rangeInput.attr("min"), 10);
    const max = parseInt($rangeInput.attr("max"), 10);
    const value = parseInt($rangeInput.val(), 10);

    // ✅ INIT BG
    const percentValue =
      Math.round(((value - min) / (max - min)) * 100 * 100) / 100;
    $rangeInput.css(
      "background",
      `linear-gradient(to right, #DB1A7D ${percentValue}%, #DB1A7D4D ${percentValue}%)`
    );

    // ✅ INIT thumb
    const $rangeThumbValue = portalContainer.find("#range__thumb-value");

    const borderForHide = 2;

    if ($rangeThumbValue) {
      if (
        (value >= min &&
          value <= min + borderForHide &&
          max - min > borderForHide * 2) ||
        (value >= max - borderForHide &&
          value <= max &&
          max - min > borderForHide * 2)
      ) {
        $rangeThumbValue.hide();
      } else {
        $rangeThumbValue.show();
        $rangeThumbValue.text(`${value}%`);

        const percent = ((value - min) / (max - min)) * 100;
        const thumbOffset = $rangeThumbValue.outerWidth() / 2;
        $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
      }

      if (value === min || value === max) {
        $rangeThumbValue.hide();
      }
    }

    // ✅ HANDLE "input"
    $rangeInput.on("input", function (event) {
      const $rangeInput = $(this);
      state[stateKey] = +event.target.value;

      const min = parseInt($rangeInput.attr("min"), 10);
      const max = parseInt($rangeInput.attr("max"), 10);
      const value = parseInt($rangeInput.val(), 10);

      const percentValue =
        Math.round(((value - min) / (max - min)) * 100 * 100) / 100;

      $rangeInput.css(
        "background",
        `linear-gradient(to right, #DB1A7D ${percentValue}%, #DB1A7D4D ${percentValue}%)`
      );

      const $rangeThumbValue = portalContainer.find("#range__thumb-value");

      if ($rangeThumbValue) {
        if (
          (value >= min &&
            value <= min + borderForHide &&
            max - min > borderForHide * 2) ||
          (value >= max - borderForHide &&
            value <= max &&
            max - min > borderForHide * 2)
        ) {
          $rangeThumbValue.hide();
        } else {
          $rangeThumbValue.show();
          $rangeThumbValue.text(`${value}%`);

          const percent = ((value - min) / (max - min)) * 100;
          const thumbOffset = $rangeThumbValue.outerWidth() / 2;
          $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
        }

        if (value === min || value === max) {
          $rangeThumbValue.hide();
        }
      }

      pergola.update();
    });
  }
}

function removeHandle(
  portalContainer,
  portalContentTitle,
  indexOfMenu,
  typeIndex
) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const electroOptions = $("#electro-group").find(".option").eq(indexOfMenu);

    electroOptions.removeClass("type_interface_electronic_item--active");

    // state[key] = false;
    state.electro.delete(portalContentTitle);

    updateTextParam(state, electroOptions, true);

    hideIcon(typeIndex);

    $(".portal-container").hide();

    state.currentActiveSystems = null;

    $(".interface-container").removeClass("interface-container-portal");

    pergola.update();
  });
}

function removeHeaters(portalContainer, indexOfMenu) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const electroOptions = $("#electro-group")
      .find(".option input[type='radio']")
      .eq(indexOfMenu);
    // electroOptions.trigger("click");

    function removeHeater() {
      removeFromUrlHeater(
        state.lastHeaterSpan.side,
        state.lastHeaterSpan.number
      );

      state.lastHeaterSpan.active = false;
      state.lastHeaterSpan.active = true;
      state.lastHeaterSpan.isLocked = true;
      state.lastHeaterSpan.isSystemSet = false;

      pergola.changeObjectVisibility(false, state.lastHeaterSpan.heater.object);

      state.lastHeaterSpan = null;

      const anyActive = pergola.spanHeater.objects.some(
        (heater) => heater.isSystemSet
      );

      if (!anyActive) {
        electroOptions.trigger("click");
      }
    }

    if (state.lastHeaterSpan) {
      removeHeater();
    } else {
      state.lastHeaterSpan = pergola.spanHeater.objects
        .filter((heater) => heater.isSystemSet)
        .at(-1);

      console.log("LAST SPAN", state.lastHeaterSpan);
      removeHeater();
    }

    // console.log(state.lastHeaterSpan.heater, "REMOVED OBJECT");

    pergola.update();
  });
}

function removeHandleSystem(
  portalContainer,
  portalContentTitle,
  key,
  indexOfMenu,
  typeIndex
) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const lastSpan = pergola.getLastActiveSpan(state.currentActiveSystems)[0];

    pergola.removeSystemFromSpan(lastSpan);

    removeFromUrlSystemBySideAndtype(
      lastSpan.side,
      state.currentActiveSystems,
      lastSpan.number
    );

    if (!pergola.checkSystemInAllSpans(state.currentActiveSystems)) {
      hideIcon(typeIndex);
      $(".portal-container").hide();

      const subSystems = $("#last-group").find(".option").eq(indexOfMenu);

      subSystems.removeClass("type_interface_electronic_item--active");

      state[key].delete(portalContentTitle);

      subSystems
        .closest(".interface__group")
        .find(".interface__group__head__param")
        .text(`${updateTextParam(state, this, false, true, true, false)}`);

      state.currentActiveSystems = null;
    } else {
      $(".portal-container__close").trigger("click");
    }

    $(".interface-container").removeClass("interface-container-portal");
    pergola.update();
    addInfoLabel();
  });
}

export const typePortalOption = {
  "LED Lights": "LED Lights",
  "Mood Light": "Mood Light",
  Fans: "Fans",
  Heaters: "Heaters",
};

export function portalComponent() {
  const bladeRange = generateRangeHTML(bladeRotation[0]).html();
  const zipRange = generateRangeHTML(zipShadeRange[0]).html();
  const slidingDoorRange = generateRangeHTML(slidingDoorRotation[0]).html();
  const biFoldRange = generateRangeHTML(biFoldDoorRange[0]).html();
  const slidingShuttersRange = generateRangeHTML(slidingShutters[0]).html();
  const shuttersRotateRange = generateRangeHTML(shuttersRotate[0]).html();
  const fixShuttersRotateRange = generateRangeHTML(fixShuttersRotate[0]).html();
  const biFoldShattersRange = generateRangeHTML(biFoldShatters[0]).html();
  const biFoldShattersRotateRange = generateRangeHTML(
    biFoldShattersRotate[0]
  ).html();

  const modelId = $("#ar_model_viewer");
  const mainContent = $("#content");

  function portalGenerete() {
    const existingPortal = mainContent.find(".portal-container");

    if (existingPortal.length > 0) {
      existingPortal.remove();
    }

    let portaInnerHtml = "";

    switch (state.portalOption) {
      case 7:
        portaInnerHtml = `
          <h3 class="portal-container__title">Mood Light</h3>
            <div class="type_interface_colors-buttons-led">
            <h3  class="portal-container__title__sub-title">Color</h3>
           
            <div class="type_interface_colors-buttons-led__options">
               <div class="type_interface_colors-buttons-led__item option">
                <label class="type_interface_colors-buttons-led__label">
                    <div class="image-container" style="background-color: #ffffff">
                    </div>
                    <span class="color-name">White</span>
                    <input class="type_interface_colors-buttons-led__option" type="radio" id="C34Bronze" name="fav_language" value="Oak">
                </label>
            </div>

            <div class="type_interface_colors-buttons-led__item option">
                <label class="type_interface_colors-buttons-led__label">
                    <div class="image-container" style="background-color: #FAFFC4">
                    </div>
                    <span class="color-name">Yellow</span>
                    <input class="type_interface_colors-buttons-led__option" type="radio" id="C34Bronze" name="fav_language" value="Oak">
                </label>
            </div>
            </div>
         
            <div class="colors_picker_container">
                <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorLed}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Color Picker
                </div>
        
                <div id="color-picker-container"></div>
            </div>
        </div>

           

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case 6:
        portaInnerHtml = `
          <h3 class="portal-container__title">${pergolaConst.optionNameString.heaters}</h3>
          <div class="main_container" style="margin: 0" id="heaters_radio">
            <ul class="radio__container">
              <li class="radio__container__item" id="0">
                <div class="radio__container__item__cyrcle"></div>
                <span class="radio__container__item__text">Dark Grey</span>
              </li>

              <li class="radio__container__item" id="1">
                <div class="radio__container__item__cyrcle"></div>
                <span class="radio__container__item__text">Stainless Steel</span>
              </li>
            </ul>
          </div>
          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case pergolaConst.systemType.zip_shade:
        portaInnerHtml = `
          <h3 class="portal-container__title">${pergolaConst.systemNameString.zip_shade}</h3>

          <div class="portal-container__range" id="zip-range_wrap">
          ${zipRange}
          </div>

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case pergolaConst.systemType.sliding_doors:
        portaInnerHtml = `
          <h3 class="portal-container__title">${pergolaConst.systemNameString.sliding_doors}</h3>

          <div class="portal-container__range" id="sliding-door-range_wrap">
          ${slidingDoorRange}
          </div>

          ${state.type3Dmodel ? `
           <div id="wrap-glass" class="canvas_menu_switch_container">
            <div class="canvas_menu__title">Frame / Frameless</div>

            <div class="switch-container">
              <div class="switch-container-sign"></div>

              <label class="switch-rot">
                <input type="checkbox" id="switch-glass">
              </label>

              <div class="switch-container-sign switch-container-sign--right"></div>
            </div>
           </div>
            ` : ""} 
          
          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case pergolaConst.systemType.sliding_shutters:
        portaInnerHtml = `
          <h3 class="portal-container__title">${pergolaConst.systemNameString.sliding_shutters}</h3>

          <div class="portal-container__range" id="sl-rotate-range_wrap">
           ${shuttersRotateRange}
          </div>

          <div class="portal-container__range" id="sl-open-range_wrap">
           ${slidingShuttersRange}
          </div>

           <div class="main_container" style="margin: 20px 0" id="shutters_radio">
            <ul class="radio__container">
              <li class="radio__container__item" id="0">
                <div class="radio__container__item__cyrcle"></div>
                <span class="radio__container__item__text">Walnut</span>
              </li>

              <li class="radio__container__item" id="1">
                <div class="radio__container__item__cyrcle"></div>
                <span class="radio__container__item__text">Oak</span>
              </li>
            </ul>
          </div>

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case pergolaConst.systemType.railing_frame:
        portaInnerHtml = `
          <h3 class="portal-container__title" style="margin-bottom: 20px;">${pergolaConst.systemNameString.railing_frame}</h3>

          <div class="main_container" style="margin: 20px 0; flex-direction: column;" id="railing_radio">
            <ul class="radio__container">
              <li class="radio__container__item" id="0">
                <div class="radio__container__item__cyrcle"></div>
                <span class="radio__container__item__text">Walnut</span>
              </li>
              
              <li class="radio__container__item" id="1">
                <div class="radio__container__item__cyrcle"></div>
                <span class="radio__container__item__text">Oak</span>
              </li>
            </ul>
            
            <h3 class="radio__container__item__text">Ralling Direction</h3>

            <div class="switch-container" id="switch-ralling">
             <div class="switch-container-sign"></div>
            </div>

           <span class="portal-container__remove">Remove</span>

          </div
          
        `;
        break;

      case 10:
        portaInnerHtml = `
          <h2 class="colors_container-title" style="margin-bottom: 20px">Roof Settings</h2>

          <h3 class="portal-container__title">Blade Rotation</h3>

          <div class="portal-container__range" id="blade-range_wrap">
          ${bladeRange}
          </div>

           <div class="select-inputs"  style="display: flex; gap: 20px;">
              <div class="type_interface_checkbox-wall_item option" id="changeDir"  style="width: fit-content;"> 
                <div class="type_interface_checkbox-wall_bottom">
                  <input class="type_interface_checkbox-wall_option" type="checkbox">
                  <label style="white-space: nowrap;" for="back">Change direction</label>
                </div> 
              </div>
           </div>
        `;

        break;

      default:
        break;
    }

    const portalContent = $(`
      <div class="portal-container">
        <div class="portal-container-wrapp">
          <span class="portal-container__close"></span>
          ${portaInnerHtml}
        </div>
      </div>
    `);

    const portalContentTitle = portalContent
      .find(`.portal-container__title`)
      .text();

    const activeColorClass = "type_interface_colors-buttons-led__item--active";

    //#region HEATERS
    if (pergolaConst.optionNameString.heaters === portalContentTitle) {
      // INIT
      portalContent
        .find("#heaters_radio .radio__container__item")
        .each(function () {
          const id = +$(this).attr("id");

          if (state.heaterType === id) {
            $(this).addClass("active");
          }

          pergola.update();
        });

      // HANDLE
      portalContent
        .find("#heaters_radio .radio__container__item")
        .on("click", function () {
          const id = +$(this).attr("id");

          state.heaterType = id;

          portalContent
            .find("#heaters_radio .radio__container__item")
            .removeClass("active");

          $(this).addClass("active");

          pergola.update();
        });

      removeHeaters(portalContent, 2);
    }
    // #endregion

    //#region RAILING
    if (pergolaConst.systemNameString.railing_frame === portalContentTitle) {
      // INIT
      portalContent
        .find("#railing_radio .radio__container__item")
        .each(function () {
          const id = +$(this).attr("id");

          if (state.railingType === id) {
            $(this).addClass("active");
          }

          pergola.update();
        });

      // HANDLE
      portalContent
        .find("#railing_radio .radio__container__item")
        .on("click", function () {
          const id = +$(this).attr("id");

          state.railingType = id;

          portalContent
            .find("#railing_radio .radio__container__item")
            .removeClass("active");

          $(this).addClass("active");

          pergola.update();
        });

      // INIT SWITCH
      portalContent.find("#switch-ralling").each(function () {
        if (state.dirRalling) {
          $(this).addClass("active");
        }
      });

      // HANDLE SWITCH
      portalContent.find("#switch-ralling").on("click", function () {
        state.dirRalling = !state.dirRalling;

        $(this).toggleClass("active");

        pergola.update();
      });
    }
    // #endregion

    //#region BLADE ROTATION
    if (bladeRotation[0].title === portalContentTitle) {
      createHandleRange(
        bladeRotation[0].title === portalContentTitle,
        portalContent,
        "currentRotationZ"
      );

      // #region INIT changeDir
      portalContent.find("#changeDir").each(function () {
        if (state.directionRoof) {
          $(this).addClass("active");
        }

        pergola.update();
      });
      //  #endregion

      //#region HANDLE changeDir
      portalContent.find("#changeDir").on("click", function () {
        const $input = $(this);

        $input.toggleClass("active");

        state.directionRoof = !state.directionRoof;

        pergola.update();
      });
      //#endregion
    }

    //#endregion

    //#region MOOD LIGHT
    if ("Mood Light" === portalContentTitle) {
      const mesh = GetGroup("base").children[1];

      //#region INIT INPUT
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .each(function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .find(".image-container")
              .css("background-color")
          );

          if (state.colorLed === backgroundColor) {
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .addClass(activeColorClass);
            $(this).prop("checked", true);
          }
        });
      //#endregion

      //#region HANDLE INPUTS
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .on("click", function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
              .find(".image-container")
              .css("background-color")
          );

          state.colorLed = backgroundColor;

          // Додаємо активний клас
          $(this)
            .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
            .addClass(activeColorClass);

          // Видаляємо активний клас у всіх інших елементах
          $(this)
            .closest(".type_interface_colors-buttons-led") // оновлений селектор
            .find(".type_interface_colors-buttons-led__item") // оновлений селектор
            .not($(this).closest(".type_interface_colors-buttons-led__item")) // оновлений селектор
            .removeClass(activeColorClass);

          // Зміна емісії кольору в mesh
          if (mesh && mesh.material) {
            mesh.material.emissive.set(state.colorLed);

            mesh.children.forEach((child) => {
              if (child.material) {
                child.material.emissive.set(state.colorLed);
              }
            });
          }
        });
      //#endregion

      //#region REMOVE BUTTON

      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-box").css("background-color", state.colorLed);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorLed,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorLed = selectedColor;

            if (mesh && mesh.material) {
              mesh.material.emissive.set(state.colorLed);

              mesh.children.forEach((child) => {
                if (child.material) {
                  child.material.emissive.set(state.colorLed);
                }
              });
            }

            portalContent
              .find("#color-box")
              .css("background-color", state.colorLed);

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );

            pergola.update();
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region LED LIGHT
    if ("LED Lights" === portalContentTitle) {
      //#region INIT INPUT
      portalContent.find(".radio__container__item").each(function () {
        const louverGap = +$(this).find(".radio__container__item__text").text();

        if (state.recessedLighting === louverGap) {
          $(this).closest(".radio__container__item").addClass("active");
        }
      });
      //#endregion

      //#region HANDLE INPUTS
      portalContent.find(".radio__container__item").on("click", function () {
        const louverGap = +$(this).find(".radio__container__item__text").text();

        state.recessedLighting = louverGap;

        portalContent.find(".radio__container__item").each(function () {
          $(this).removeClass("active");
        });

        $(this).addClass("active");

        pergola.update();
      });
      //#endregion

      //#region REMOVE BUTTON

      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorLed,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorLed = selectedColor;

            if (mesh && mesh.material) {
              mesh.material.emissive.set(state.colorLed);

              mesh.children.forEach((child) => {
                if (child.material) {
                  child.material.emissive.set(state.colorLed);
                }
              });
            }

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region ZIP-SHADE
    if (pergolaConst.systemNameString.zip_shade === portalContentTitle) {
      //#region INIT INPUT
      //#region INIT COLOR
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .each(function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .find(".image-container")
              .css("background-color")
          );

          if (state.colorZip === backgroundColor) {
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .addClass(activeColorClass);
            $(this).prop("checked", true);
          }
        });
      //#endregion

      //#region transparency
      portalContent.find(".radio__container__item").each(function () {
        const transparency = $(this)
          .find(".radio__container__item__text")
          .attr("id");

        if (state.transparency === transparency) {
          $(this).closest(".radio__container__item").addClass("active");
        }
      });
      //#endregion

      //#region INIT RANGE
      const $rangeThumbValue = portalContent.find("#range__thumb-value");

      $rangeThumbValue.text(`${state.zipInput}%`);
      //#endregion

      //#region INIT COLOR PICKER
      portalContent.find("#color-box").css("background-color", state.colorZip);
      //#endregion

      //#endregion

      //#region HANDLE INPUTS
      //#region COLOR HANDLE
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .on("click", function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
              .find(".image-container")
              .css("background-color")
          );

          state.colorZip = backgroundColor;

          $(this)
            .closest(".type_interface_colors-buttons-led__item")
            .addClass(activeColorClass);

          $(this)
            .closest(".type_interface_colors-buttons-led")
            .find(".type_interface_colors-buttons-led__item")
            .not($(this).closest(".type_interface_colors-buttons-led__item")) // оновлений селектор
            .removeClass(activeColorClass);

          pergola.update();
        });
      //#endregion

      //#region transparency INPUTS
      portalContent.find(".radio__container__item").on("click", function () {
        const transparency = $(this)
          .find(".radio__container__item__text")
          .attr("id");

        state.transparency = transparency;

        portalContent.find(".radio__container__item").each(function () {
          $(this).removeClass("active");
        });

        $(this).addClass("active");

        pergola.update();
      });
      //#endregion

      //#region open INPUTS

      createHandleRange(true, portalContent, "zipInput");
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        0,
        pergolaConst.systemType.zip_shade
      );

      //#endregion
      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorZip,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorZip = selectedColor;

            // if (mesh && mesh.material) {
            //   mesh.material.emissive.set(state.colorLed);

            //   mesh.children.forEach((child) => {
            //     if (child.material) {
            //       child.material.emissive.set(state.colorLed);
            //     }
            //   });
            // }

            portalContent
              .find("#color-box")
              .css("background-color", state.colorZip);

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );

            pergola.update();
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region SLIDING DOOR
    if (pergolaConst.systemNameString.sliding_doors === portalContentTitle) {
      createHandleRange(true, portalContent, "slidingDoorInput");

      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        1,
        pergolaConst.systemType.sliding_doors
      );
    }

      // #region INIT changeDir
      portalContent.find("#switch-glass").each(function () {
        if (state.typeSlideGlass) {
          $(this).addClass("active");
        }

        pergola.update();
      });
      //  #endregion

      //#region HANDLE changeDir
      portalContent.find("#switch-glass").on("click", function () {
        const $input = $(this);

        $input.toggleClass("active");

        state.typeSlideGlass = !state.typeSlideGlass;

        pergola.update();
      });
      //#endregion

    //#endregion

    //#region BI-FOLD DOOR
    if (pergolaConst.systemNameString.bifold_doors === portalContentTitle) {
      createHandleRange(true, portalContent, "biFoldDoorInput");

      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        2,
        pergolaConst.systemType.bifold_doors
      );
    }

    //#endregion

    //#region SLIDING-SHATTERS
    if (pergolaConst.systemNameString.sliding_shutters === portalContentTitle) {
      // INIT
      portalContent
        .find("#shutters_radio .radio__container__item")
        .each(function () {
          const id = +$(this).attr("id");

          if (state.shuttersType === id) {
            $(this).addClass("active");
          }

          pergola.update();
        });

      // HANDLE
      portalContent
        .find("#shutters_radio .radio__container__item")
        .on("click", function () {
          const id = +$(this).attr("id");

          state.shuttersType = id;

          portalContent
            .find("#shutters_radio .radio__container__item")
            .removeClass("active");

          $(this).addClass("active");

          pergola.update();
        });

      //OPEN
      createHandleRange(
        true,
        portalContent,
        "slidingShuttersInput",
        "#sl-open-range_wrap .range__input"
      );

      //ROTATE
      createHandleRange(
        true,
        portalContent,
        "slidingShuttersRotate",
        "#sl-rotate-range_wrap .range__input"
      );

      $("#sl-rotate-range_wrap .range__input").trigger("change");
      $("#sl-rotate-range_wrap .range__input").trigger("input");

      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        2,
        pergolaConst.systemType.sliding_shutters
      );
    }

    //#endregion

    //#region FIX SHATTERS
    if (pergolaConst.systemNameString.railing_frame === portalContentTitle) {
      //REMOVE
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        3,
        pergolaConst.systemType.railing_frame
      );
    }
    //#endregion

    //#region BI-FOLD-SHATTERS
    if (pergolaConst.systemNameString.bifold_shutters === portalContentTitle) {
      //OPEN
      createHandleRange(
        true,
        portalContent,
        "biFoldDoorShattersInput",
        "#bs-open-range_wrap .range__input"
      );

      //ROTATE
      createHandleRange(
        true,
        portalContent,
        "biFoldDoorShattersRotate",
        "#bs-rotate-range_wrap .range__input"
      );

      //REMOVE
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        5,
        pergolaConst.systemType.bifold_shutters
      );
    }
    // #endregion

    // #region SLATS

    if (pergolaConst.systemNameString.slats_frame === portalContentTitle) {
      //#region SLATS SIZE INIT
      const items = portalContent.find(".radio__container__item");

      items.removeClass("active");

      if (!state.slatsSize) {
        items.eq(0).addClass("active");
      } else {
        items.eq(1).addClass("active");
      }
      //#endregion

      //#region SLATS SIZE HANDLE
      portalContent.find(".radio__container__item").on("click", function () {
        if ($(this).hasClass("active")) return;

        const size = $(this).find(".radio__container__item__text").attr("id");

        state.slatsSize = +size === 60;

        portalContent.find(".radio__container__item").removeClass("active");
        $(this).addClass("active");

        pergola.update();
      });
      //#endregion

      //REMOVE
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        6,
        pergolaConst.systemType.slats_frame
      );
    }

    // #endregion

    //#enregion

    mainContent.append(portalContent);

    return portalContent;
  }

  const icons = $(`
    <div class="icon_wrap">
    <div class="left_button"></div>

    <div class="icon_container">
       <div class="sun__icon" id="7" data-value="Mood Light">
          <span class="sun__icon__img" id="light-n" style="
              background-image: url(public/img/icons/moodlight_icon.svg);
          "></span>
       </div>

        <div class="sun__icon" id="6" data-value="${pergolaConst.optionNameString.heaters}">
          <span class="sun__icon__img" id="heaters" style="
              background-image: url(public/img/icons/heater-r.svg);
          "></span>
       </div>

       <div class="sun__icon" id="${pergolaConst.systemType.zip_shade}" data-value="${pergolaConst.systemNameString.zip_shade}">
          <span class="sun__icon__img" id="zip" style="
              background-image: url(public/img/icons/zip-r.svg);
          "></span>
       </div>

        <div class="sun__icon" id="${pergolaConst.systemType.sliding_doors}" data-value="Sliding Glass Door">
          <span class="sun__icon__img" id="sliding-doors" style="
              background-image: url(public/img/icons/slide-d-r.svg);
          "></span>
       </div>

       <div class="sun__icon" id="${pergolaConst.systemType.sliding_shutters}" data-value="Sliding Shutters">
          <span class="sun__icon__img" id="sliding-shutters" style="
              background-image: url(public/img/icons/slide-s-r.svg);
          "></span>
       </div>

       <div class="sun__icon" id="${pergolaConst.systemType.railing_frame}" data-value="Railing">
          <span class="sun__icon__img" id="railing_frame" style="
              background-image: url(public/img/icons/ralling-r.svg);
          "></span>
       </div>

       <div class="sun__icon" id="10" data-value="Blade Rotation">
          <span class="sun__icon__img" id="blade-rotation" style="
              background-image: url(public/img/icons/blade-r.svg);
          "></span>
       </div>
    </div> 

    <div class="right_button"></div>
    </div>
    `);

  modelId.append(icons);

  function scrollLogic() {
    const $iconContainer = $(".icon_container");
    const $leftButton = $(".left_button");
    const $rightButton = $(".right_button");

    function updateButtonVisibility() {
      $(".icon_container").removeClass("icon_container-mobile");

      if ($iconContainer.scrollLeft() === 0) {
        $leftButton.hide();
      } else {
        $leftButton.show();
        $(".icon_container").addClass("icon_container-mobile");
      }

      if (
        $iconContainer.scrollLeft() + $iconContainer.innerWidth() >=
        $iconContainer[0].scrollWidth - 1
      ) {
        $rightButton.hide();
      } else {
        $rightButton.show();
        $(".icon_container").addClass("icon_container-mobile");
      }
    }

    updateButtonVisibility();

    $leftButton.on("click", function () {
      $iconContainer.animate(
        { scrollLeft: "-=50" },
        100,
        updateButtonVisibility
      );
    });

    $rightButton.on("click", function () {
      $iconContainer.animate(
        { scrollLeft: "+=50" },
        100,
        updateButtonVisibility
      );
    });

    $iconContainer.on("scroll", updateButtonVisibility);
  }

  const activeClassNight = "night-mode";
  const activeClassDay = "day-mode";
  const daySwitch = modelId.find("#daySwitch");
  const nightSwitch = modelId.find("#nightSwitch");
  const toggleTime = modelId.find("#js-toggleDayNight");
  const icon = icons.find(".sun__icon");
  const portalLight = mainContent.find(".portal-light");

  const sunIcon = icons.find("#light");

  //#region INIT TIME SCENE
  if (state.dayMode) {
    toggleTime.removeClass("switch--hight");
    daySwitch.prop("checked", true);
    daySwitch.closest("label").addClass(activeClassDay);
    nightSwitch.closest("label").removeClass(activeClassNight);
    $("body").removeClass("night-mode").addClass("day-mode");

    modelId.find("#switchButton-time").removeClass("switchButton-active");

    $("#js-showModalShare").removeClass("share-white");
    $("#js-showModalQRcode").removeClass("ar-white");
    $(".full-screen").removeClass("full-screen-white");
    $(".sun__icon").removeClass("sun__icon--night");
    $("#shutters").removeClass("shutters");
    $("#glassDoors").removeClass("glassDoors");
    $("#shades").removeClass("shades");
    $("#railing").removeClass("railing");
    $("#heaters").removeClass("heaters-n");
    $("#roof").removeClass("roof");
    $("#switchButton-time").removeClass("switchButton-night");

    changeSceneTime("Day");
  } else {
    toggleTime.addClass("switch--hight");
    nightSwitch.prop("checked", true);
    nightSwitch.closest("label").addClass(activeClassNight);
    daySwitch.closest("label").removeClass(activeClassDay);
    $("body").removeClass("day-mode").addClass("night-mode");

    modelId.find("#switchButton-time").addClass("switchButton-active");

    $("#js-showModalShare").addClass("share-white");
    $("#js-showModalQRcode").addClass("ar-white");
    $(".full-screen").addClass("full-screen-white");
    $(".sun__icon").addClass("sun__icon--night");
    $("#shutters").addClass("shutters");
    $("#glassDoors").addClass("glassDoors");
    $("#shades").addClass("shades");
    $("#railing").addClass("railing");
    $("#heaters").addClass("heaters-n");
    $("#roof").addClass("roof");
    $("#switchButton-time").addClass("switchButton-night");

    changeSceneTime("Night");
  }
  //#endregion

  //#region HANDLE TIME SCENE
  modelId.find("#switchButton-time").on("click", function () {
    state.dayMode = !state.dayMode;

    $(this).toggleClass("switchButton-active");
    // const isDay = daySwitch.is(":checked");

    if (state.dayMode) {
      toggleTime.removeClass("switch--hight");
      daySwitch.closest("label").addClass(activeClassDay);
      nightSwitch.closest("label").removeClass(activeClassNight);
      $("body").removeClass("night-mode").addClass("day-mode");

      $("#js-showModalShare").removeClass("share-white");
      $("#js-showModalQRcode").removeClass("ar-white");
      $(".full-screen").removeClass("full-screen-white");
      $(".sun__icon").removeClass("sun__icon--night");
      $("#shutters").removeClass("shutters");
      $("#glassDoors").removeClass("glassDoors");
      $("#shades").removeClass("shades");
      $("#railing").removeClass("railing");
      $("#heaters").removeClass("heaters-n");
      $("#switchButton-time").removeClass("switchButton-night");

      changeSceneTime("Day");
    } else {
      toggleTime.addClass("switch--hight");
      nightSwitch.closest("label").addClass(activeClassNight);
      daySwitch.closest("label").removeClass(activeClassDay);
      $("body").removeClass("day-mode").addClass("night-mode");

      $("#js-showModalShare").addClass("share-white");
      $("#js-showModalQRcode").addClass("ar-white");
      $(".full-screen").addClass("full-screen-white");
      $(".sun__icon").addClass("sun__icon--night");
      $("#shutters").addClass("shutters");
      $("#glassDoors").addClass("glassDoors");
      $("#shades").addClass("shades");
      $("#railing").addClass("railing");
      $("#heaters").addClass("heaters-n");
      $("#switchButton-time").addClass("switchButton-night");

      changeSceneTime("Night");
    }
  });
  //#endregion

  //#region ICON LOGIC
  // INIT POP-UP
  setTimeout(() => {
    icon.each(function () {
      const id = $(this).attr("id");
      const activeClass = `sun__icon-active--${id}`;

      if ($(this).hasClass(activeClass)) {
        $(this).trigger("click");
        return false;
      }
    });
  }, 500);

  icon.each(function () {
    const id = $(this).attr("id");
    //INIT ICON

    if (id !== "10") {
      $(this).hide();
    }
    // else if (["Windows", "Linux", "Macintosh"].includes(currentOS)) {
    //   // setTimeout(() => {
    //   //   showIcon(10, true, true);
    //   // }, 1000);
    // }

    $(this).on("click", function () {
      icon.each(function () {
        $(this).removeClass("active");
      });

      state.portalOption = +id;

      //blade rotation
      if (+id !== 10 && +id !== 7 && +id !== 6) {
        state.currentActiveSystems = +id;
        state.activeHotspotHeater = false;
      } else if (+id === 6) {
        state.activeHotspotHeater = true;
        state.currentActiveSystems = null;
      } else {
        state.currentActiveSystems = null;
        state.activeHotspotHeater = false;
      }

      $(this).toggleClass(`active`);

      const portal = portalGenerete();

      const iconOffset = $(this).offset();

      $(".interface-container").addClass("interface-container-portal");

      portal.css({
        top: iconOffset.top + $(this).outerHeight() - 30,
        left: iconOffset.left,
      });

      pergola.update();
    });
  });

  //#region CLOSE PORTAL
  $(document).on("click", ".portal-container__close", function () {
    $(".interface-container").removeClass("interface-container-portal");
    state.currentActiveSystems = null;
    state.activeHotspotHeater = false;

    const existingPortal = mainContent.find(".portal-container");

    if (existingPortal.length > 0) {
      existingPortal.remove();
    }

    icon.each(function () {
      $(this).removeClass("active");
    });

    pergola.update();
    pergola.checkSystemsInScene();
  });

  // #endregion
  //#endregion

  //light range
  const customRange = generateRangeHTML(lightRange[0]);
  const customRangeShades = generateRangeHTML(shadesRange[0]);
  const rangeContainer = mainContent.find(".portal-light__range");
  const rangeContainerShades = mainContent.find(".portal-shades__range");
  const iconBlade = icons.find("#10");

  rangeContainer.append(customRange);
  rangeContainerShades.append(customRangeShades);

  scrollLogic();

  $(window).on("resize", function () {
    $(".icon_container").trigger("scroll");

    icon.each(function () {
      const id = $(this).attr("id");
      const activeClass = `sun__icon-active--${id}`;

      if ($(this).hasClass(activeClass)) {
        $(this).trigger("click");
        return false;
      }
    });
  });

  return { portal: portalLight, sunIcon };
}
